<!-- Initial loading state with skeletons - only in endless scroll mode -->
@if (!isPaging() && (listingLoading$ | async) && (!products().length || isSorting)) {
<div class="product-list-skeletons col-12">
  @if (isGrid) {
  <div class="row">
    @for (i of [].constructor(skeletonCount); track i) {
    <div class="col-6 col-lg-{{ colSize }} product-skeleton grid">
      <div class="skeleton-card">
        <div class="skeleton-image shimmer"></div>
        <div class="skeleton-lines">
          <div class="skeleton-line title shimmer"></div>
          <div class="skeleton-line price shimmer"></div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if (isList) {
  <div class="list-skeletons">
    @for (i of [].constructor(skeletonCount); track i) {
    <div class="col-12 product-skeleton list">
      <div class="skeleton-row">
        <div class="skeleton-image-wide shimmer"></div>
        <div class="skeleton-row-content">
          <div class="skeleton-line title shimmer"></div>
          <div class="skeleton-line desc shimmer"></div>
          <div class="skeleton-line price shimmer"></div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
}
<div class="product-list row">
  <!-- No results message when there are no products and not loading -->
  @if (!products().length && (listingLoading$ | async) === false) {
  <div>
    {{ 'search.noresult.filtered_products.message' | translate }}
  </div>
  }

  <!-- Always render currently loaded products (supports infinite scroll) -->
  @for (sku of products(); track sku) {
  <ng-container
    ishProductContext
    [sku]="sku"
    [categoryId]="categoryId()"
    [configuration]="{ shipment: false, quantity: false, sku: false, inventory: false }"
  >
    @if (isGrid) {
    <div class="col-6 col-lg-{{ colSize }} product-list-item grid-view">
      <ish-product-item displayType="tile" />
    </div>
    } @if (isList) {
    <div class="col-lg-12 product-list-item list-view">
      <ish-product-item displayType="row" />
    </div>
    }
  </ng-container>
  }
</div>
<!-- Append skeletons at the bottom while loading more products - only in endless scroll mode -->
@if (!isPaging() && (listingLoading$ | async) && products().length && !isSorting) {
<div class="product-list-skeletons col-12">
  @if (isGrid) {
  <div class="row">
    @for (i of [].constructor(skeletonCount); track i) {
    <div class="col-6 col-lg-{{ colSize }} product-skeleton grid">
      <div class="skeleton-card">
        <div class="skeleton-image shimmer"></div>
        <div class="skeleton-lines">
          <div class="skeleton-line title shimmer"></div>
          <div class="skeleton-line price shimmer"></div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if (isList) {
  <div class="list-skeletons">
    @for (i of [].constructor(skeletonCount); track i) {
    <div class="col-12 product-skeleton list">
      <div class="skeleton-row">
        <div class="skeleton-image-wide shimmer"></div>
        <div class="skeleton-row-content">
          <div class="skeleton-line title shimmer"></div>
          <div class="skeleton-line desc shimmer"></div>
          <div class="skeleton-line price shimmer"></div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
}
